/**
 *  Slider
 *  Use jQuery & Owl Carrousel
 */
;(function slider($) {

    $(document).ready(init);

    var CONTAINER = '.js-Slider2';
    var PREV = '.js-Slider2-prev';
    var NEXT = '.js-Slider2-next';

    var OPTIONS = {
        animation: 'fade',
        animationSpeed: 1000,
        slideshowSpeed: 3500,
        controlNav: false,
        directionNav: false
    };

    function init() {
        var container = $(CONTAINER);

        if (container.length) {
            container.flexslider(OPTIONS);

            // Prev/next buttons
            container.find(PREV).on('click', function () {
                container.flexslider('prev')
            });
            container.find(NEXT).on('click', function () {
                container.flexslider('next')
            });
        }
    }

}(jQuery));
